export const adaptReporteVenta = (reporteVentaData) => {
    return {
        id: reporteVentaData?.idReporteVenta,
        displayName: reporteVentaData?.descripcion,
        name: reporteVentaData?.descripcion
    }
}

export const adaptReporteVentaArray = (
    reporteVentas
) => {
    return structuredClone(reporteVentas?.allReporteVenta)
        ?.map(reporteVenta => adaptReporteVenta(reporteVenta));
}